import { Size } from '@/hooks/useScreenSize';

const bulletImageClassMap: Record<Size, { width: number; height: number; bulletDiv: string }> = {
  sm: { width: 8.82, height: 6.74, bulletDiv: 'w-[27px] h-[27px]' },
  md: { width: 11.46, height: 8.77, bulletDiv: 'w-[35.1px] h-[35.1px]' },
  lg: { width: 14.9, height: 11.4, bulletDiv: 'w-[45.63px] h-[45.63px]' },
  xl: { width: 14.9, height: 11.4, bulletDiv: 'w-[45.63px] h-[45.63px]' },
  xxl: { width: 19.38, height: 14.82, bulletDiv: 'w-[59.32px] h-[59.32px]' },
};

const tcBulletImageClassMap: Record<Size, { width: number; height: number; bulletDiv: string }> = {
  sm: { width: 15, height: 16.67, bulletDiv: 'w-[27px] h-[27px]' },
  md: {
    width: 19.5,
    height: 21.67,
    bulletDiv: 'w-[35.1px] h-[35.1px] flex justify-center !object-contain',
  },
  lg: { width: 25.35, height: 28.17, bulletDiv: 'w-[45.63px] h-[45.63px]' },
  xl: { width: 25.35, height: 28.17, bulletDiv: 'w-[45.63px] h-[45.63px]' },
  xxl: { width: 32.96, height: 36.62, bulletDiv: 'w-[59.32px] h-[59.32px]' },
};

const listClassMap: Record<Size, string> = {
  sm: 'items-center',
  md: 'pb-4 items-center',
  lg: 'items-center',
  xl: 'items-center',
  xxl: 'items-center',
};

const lozengeImageClassMap: Record<Size, string> = {
  sm: 'h-[32px]',
  md: 'h-[41.6px]',
  lg: 'h-[54.08px]',
  xl: 'h-[54.08px]',
  xxl: 'h-[70.3px]',
};
const lozengeTextClassMap: Record<Size, string> = {
  sm: 'text-fontsize-paragraph-SubTitle-2xs leading-line-height-md pb-[4px]',
  md: 'text-fontsize-paragraph-SubTitle-xs font-[700] leading-line-height-lg pb-[6px]',
  lg: 'text-fontsize-paragraph-SubTitle-sm font-[700] leading-line-height-xl pb-[8px]',
  xl: 'text-fontsize-paragraph-SubTitle-sm font-[700] leading-line-height-xl pb-[8px]',
  xxl: 'text-fontsize-paragraph-SubTitle-md font-[700] leading-line-height-2xl pb-[8px]',
};

const linkClassMap: Record<Size, string> = {
  sm: 'font-[700] !text-font-size-paragraph-bulletPoints-bold-md !leading-lineHeight-xl text-color-content-text-primary',
  md: 'font-[700] !text-font-size-paragraph-bulletPoints-bold-lg !leading-lineHeight-2xl pl-2 text-color-content-text-primary',
  lg: 'font-[700] !text-font-size-paragraph-bulletPoints-bold-xl !leading-lineHeight-4xl  pl-2 text-color-content-text-primary',
  xl: 'font-[700] !text-font-size-paragraph-bulletPoints-bold-xl !leading-lineHeight-4xl  pl-2 text-color-content-text-primary',
  xxl: 'font-[700] !text-font-size-paragraph-bulletPoints-bold-2xl !leading-lineHeight-7xl  pl-2 text-color-content-text-primary',
};
const ChannelContainerClassMap: Record<Size, string> = {
  sm: ' w-[296px]',
  md: ' w-[750px]',
  lg: ' w-[750px]',
  xl: ' w-[750px]',
  xxl: ' w-[750px]',
};
const channelHeaderClassMap: Record<Size, string> = {
  sm: 'h-[56px] w-[296px]',
  md: 'h-[64px] w-[750px]',
  lg: 'h-[80px] w-[750px]',
  xl: 'h-[80px] w-[750px]',
  xxl: 'h-[96px] w-[750px]',
};
const channelTitleClassMap: Record<Size, string> = {
  sm: ' font-[700] text-fontSize-paragraph-bulletPoints-bold-md leading-lineHeight-xl text-color-content-text-primary ',
  md: 'font-[700]  text-fontSize-paragraph-bulletPoints-bold-lg leading-lineHeight-2xl text-color-content-text-primary',
  lg: ' font-[700]  text-fontSize-paragraph-bulletPoints-bold-xl leading-lineHeight-4xl text-color-content-text-primary font-[700]',
  xl: ' font-[700]  text-fontSize-paragraph-bulletPoints-bold-xl leading-lineHeight-4xl text-color-content-text-primary font-[700]',
  xxl: ' font-[700]  text-fontSize-paragraph-bulletPoints-bold-2xl leading-lineHeight-7xl text-color-content-text-primary font-[700]',
};
const channelSubTitleClassMap: Record<Size, string> = {
  sm: 'font-[450] text-fontSize-paragraph-bulletPoints-book-md leading-lineHeight-xl text-color-content-text-primary ',
  md: 'font-[450]  text-fontSize-paragraph-bulletPoints-book-lg leading-lineHeight-2xl text-color-content-text-primary ',
  lg: 'font-[450]  text-fontSize-paragraph-bulletPoints-book-xl leading-lineHeight-4xl text-color-content-text-primary ',
  xl: 'font-[450]  text-fontSize-paragraph-bulletPoints-book-xl leading-lineHeight-4xl text-color-content-text-primary ',
  xxl: 'font-[450]  text-fontSize-paragraph-bulletPoints-book-2xl leading-lineHeight-7xl text-color-content-text-primary ',
};

const textClassMap: Record<Size, string> = {
  sm: 'font-[450]  !text-fontSize-paragraph-bulletPoints-book-md !leading-lineHeight-xl',
  md: 'font-[450]  !text-fontSize-paragraph-bulletPoints-book-lg !leading-lineHeight-2xl',
  lg: 'font-[450]  !text-fontSize-paragraph-bulletPoints-book-xl !leading-lineHeight-4xl',
  xl: 'font-[450]  !text-fontSize-paragraph-bulletPoints-book-xl !leading-lineHeight-4xl',
  xxl: 'font-[450]  !text-fontSize-paragraph-bulletPoints-book-xl !leading-lineHeight-4xl',
};
const titleTCClassMap: Record<Size, string> = {
  sm: 'text-fontSize-bodyRegular-md font-[450] leading-lineHeight-xl text-color-content-text-primary tracking-spacing-6xs',
  md: 'font-[450] text-fontSize-bodyRegular-lg leading-lineHeight-2xl w-[736px] tracking-spacing-5xs text-color-content-text-primary',
  lg: 'text-fontSize-bodyRegular-xl font-[450] leading-lineHeight-4xl w-[660px] tracking-spacing-5xs text-color-content-text-primary',
  xl: 'text-fontSize-bodyRegular-xl font-[450] leading-lineHeight-4xl w-[660px] tracking-spacing-5xs  text-color-content-text-primary',
  xxl: 'text-fontSize-bodyRegular-xl font-[450] leading-lineHeight-4xl w-[660px] tracking-spacing-4xs text-color-content-text-primary',
};
const tcContainerClassMap: Record<Size, string> = {
  sm: 'gap-3 pt-spacing-3xl w-[296px]',
  md: 'gap-3 pt-spacing-spacing-42 w-[736px]',
  lg: 'gap-3 pt-8 w-[660px]',
  xl: 'gap-3 py-8 w-[660px]',
  xxl: 'gap-3 py-8 w-[660px]',
};
const accordionContClassMap: Record<Size, string> = {
  sm: 'w-[296px]',
  md: 'w-[634px]',
  lg: 'w-[500px]',
  xl: 'w-[500px]',
  xxl: 'w-[500px]',
};
const accordionTitleClassMap: Record<Size, string> = {
  sm: 'w-[204px] font-[700]  text-fontSize-paragraph-SubTitle-sm  leading-lineHeight-xl text-color-content-text-primary',
  md: 'w-[474px] font-[700]  text-fontSize-paragraph-SubTitle-md leading-lineHeight-2xl text-color-content-text-primary',
  lg: 'w-[344.76px] font-[700] text-fontSize-paragraph-SubTitle-lg leading-lineHeight-4xl text-color-content-text-primary',
  xl: 'w-[344.76px] font-[700] text-fontSize-paragraph-SubTitle-lg leading-lineHeight-4xl text-color-content-text-primary',
  xxl: 'w-[448.19px] font-[700] text-fontSize-paragraph-SubTitle-xl  leading-lineHeight-7xl text-color-content-text-primary',
};
const accordionParaClassMap: Record<Size, { width: string; class: string }> = {
  sm: {
    width: 'w-[254px]',
    class: 'text-fontSize-paragraph-body-sm font-[450] font-[450] leading-lineHeight-xl',
  },
  md: {
    width: 'w-[559px]',
    class: 'text-fontSize-paragraph-body-md font-[450] font-[450] leading-lineHeight-2xl',
  },
  lg: {
    width: 'w-[429.26px]',
    class: 'text-fontSize-paragraph-body-lg font-[450] font-[450] leading-lineHeight-4xl',
  },
  xl: {
    width: 'w-[429.26px]',
    class: 'text-fontSize-paragraph-body-lg font-[450] font-[450] leading-lineHeight-4xl',
  },
  xxl: {
    width: 'w-[558.04px]',
    class: 'text-fontSize-paragraph-body-lg font-[450] font-[450] leading-lineHeight-7xl',
  },
};
const triggerIconClassMap: Record<Size, { dimension: string }> = {
  sm: { dimension: 'w-[27px] h-[27px]' },
  md: { dimension: 'w-[35.1px] h-[35.1px]' },
  lg: { dimension: 'w-[45.63px] h-[45.63px]' },
  xl: { dimension: 'w-[45.63px] h-[45.63px]' },
  xxl: {
    dimension: 'w-[45.63px] h-[45.63px]',
  },
};

const bullutPointContainerClassMap: Record<Size, string> = {
  sm: 'flex items-center gap-[16px]',
  md: 'flex items-center gap-[16px]',
  lg: 'flex items-start gap-[16px]',
  xl: 'flex items-start gap-[16px]',
  xxl: 'flex items-start gap-[16px]',
};
const bullutImgContainerClassMap: Record<Size, string> = {
  sm: 'flex justify-center shrink-0 size-[27px]',
  md: 'flex justify-center shrink-0 size-[35.1px]',
  lg: 'flex justify-center shrink-0 size-[45.63px]',
  xl: 'flex justify-center shrink-0 size-[45.63px]',
  xxl: 'flex justify-center shrink-0 size-[59.32px]',
};

const tickContainerClassMap: Record<Size, string> = {
  sm: 'w-[27px] h-[27px] rounded-full flex items-center justify-center',
  md: 'w-[35.1px] h-[35.1px] rounded-full flex items-center justify-center',
  lg: 'w-[45.63px] h-[45.63px] rounded-full flex items-center justify-center',
  xl: 'w-[45.63px] h-[45.63px] rounded-full flex items-center justify-center',
  xxl: 'w-[45.63px] h-[45.63px] rounded-full flex items-center justify-center',
};

const tickIconClassMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 8.82, height: 6.74 },
  md: { width: 11.46, height: 8.77 },
  lg: { width: 14.9, height: 11.4 },
  xl: { width: 14.9, height: 11.4 },
  xxl: { width: 19.38, height: 14.82 },
};

const infoContainerClassMap: Record<Size, string> = {
  sm: 'w-[18.81px] h-[18.81px] rounded-full flex-center',
  md: 'w-[24.45px] h-[24.5px] rounded-full flex-center',
  lg: 'w-[31.78px] h-[31.78px] rounded-full flex-center',
  xl: 'w-[31.78px] h-[31.78px] rounded-full flex-center',
  xxl: 'w-[41.32px] h-[41.32px] rounded-full flex-center',
};

const bullutIconClassMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 18.81, height: 18.81 },
  md: { width: 24.45, height: 24.45 },
  lg: { width: 31.78, height: 31.78 },
  xl: { width: 31.78, height: 31.78 },
  xxl: { width: 41.32, height: 41.32 },
};

const bullutTextContainerClassMap: Record<Size, string> = {
  sm: 'ml-[4px]',
  md: 'ml-[10.4px]',
  lg: 'ml-[13.5px]',
  xl: 'ml-[13.5px]',
  xxl: 'ml-[17.58px]',
};

const bullutTextClassMap: Record<Size, string> = {
  sm: 'text-fontSize-paragraph-bulletPoints-book-sm font-[450] text-color-content-text-primary leading-line-height-sm',
  md: 'text-fontSize-paragraph-bulletPoints-book-md font-[450] text-color-content-text-primary leading-line-height-xl',
  lg: 'text-fontSize-paragraph-bulletPoints-book-lg font-[450] text-color-content-text-primary leading-line-height-2xl',
  xl: 'text-fontSize-paragraph-bulletPoints-book-lg font-[450] text-color-content-text-primary leading-line-height-2xl',
  xxl: 'text-fontSize-paragraph-bulletPoints-book-xl font-[450] text-color-content-text-primary leading-line-height-4xl',
};

const legalLineTextClassMap: Record<Size, string> = {
  sm: 'text-font-size-paragraph-legal-sm font-[450] text-color-content-text-secondary leading-line-height-sm',
  md: 'text-font-size-paragraph-legal-md font-[450] text-color-content-text-secondary leading-line-height-md',
  lg: 'text-font-size-paragraph-legal-lg font-[450] text-color-content-text-secondary leading-line-height-xl',
  xl: 'text-font-size-paragraph-legal-lg font-[450] text-color-content-text-secondary leading-line-height-xl',
  xxl: 'text-font-size-paragraph-legal-lg font-[450] text-color-content-text-secondary leading-line-height-xl',
};

const termsIconClassMap: Record<Size, { width: number; height: number }> = {
  sm: { width: 10.5, height: 11.7 },
  md: { width: 13.7, height: 15.2 },
  lg: { width: 17.84, height: 17.84 },
  xl: { width: 17.84, height: 17.84 },
  xxl: { width: 32.96, height: 36.62 },
};

const textTitleClassMap: Record<Size, string> = {
  sm: 'max-w-[312px] text-[20.28px] leading-[29.203px] text-color-content-text-primary font-[700]',
  md: 'max-w-[702px] text-[26.364px] leading-[37.964px] text-color-content-text-primary font-[700]',
  lg: 'max-w-[626px] text-[26.364px] leading-[37.964px] text-color-content-text-primary font-[700]',
  xl: 'max-w-[626px] text-[26.364px] leading-[37.964px] text-color-content-text-primary font-[700]',
  xxl: 'max-w-[626px] text-[26.364px] leading-[37.964px] text-color-content-text-primary font-[700]',
};

const cardLineGradientClassMap: Record<Size, string> = {
  sm: 'h-[2px] w-full bg-Gradients-section-divider-default-secondary shadow-sectiondividerShadow border-solid  border-Gradients-section-divider-default-secondary',
  md: 'h-[2px] w-full bg-Gradients-section-divider-default-secondary shadow-sectiondividerShadow  border-solid border-Gradients-section-divider-default-secondary',
  lg: 'h-[2px] w-full bg-Gradients-section-divider-default-secondary shadow-sectiondividerShadow  border-solid border-Gradients-section-divider-default-secondary',
  xl: 'h-[2px] w-full bg-Gradients-section-divider-default-secondary shadow-sectiondividerShadow  border-solid border-Gradients-section-divider-default-secondary',
  xxl: 'h-[2px] w-full bg-Gradients-section-divider-default-secondary shadow-sectiondividerShadow  border-solid border-Gradients-section-divider-default-secondary',
};

const closeImgClassMap: Record<Size, string> = {
  sm: 'w-[21px] h-[21px] !object-contain',
  md: 'w-[21px] h-[21px] !object-contain',
  lg: 'w-[45.63px] h-[45.63px] !object-contain',
  xl: 'w-[45.63px] h-[45.63px] !object-contain',
  xxl: 'w-[59.3px] h-[59.3px] !object-contain',
};

const titleImgClassMap: Record<Size, string> = {
  sm: 'h-[27.035px] !object-contain mt-2',
  md: 'h-[35.146px] !object-contain mt-2',
  lg: 'h-[31.2px] !object-contain',
  xl: 'h-[31.2px] !object-contain',
  xxl: 'h-[31.2px] !object-contain',
};

const dialogTitleContainerClassMap: Record<Size, string> = {
  sm: 'pt-8',
  md: 'pt-8',
  lg: '',
  xl: '',
  xxl: '',
};

const dialogTitleImgContainerClassMap: Record<Size, string> = {
  sm: 'w-[296px] m-auto',
  md: 'w-[702px] m-auto',
  lg: '',
  xl: '',
  xxl: '',
};

export {
  bulletImageClassMap,
  listClassMap,
  lozengeTextClassMap,
  linkClassMap,
  channelHeaderClassMap,
  textClassMap,
  titleTCClassMap,
  ChannelContainerClassMap,
  channelTitleClassMap,
  channelSubTitleClassMap,
  tcContainerClassMap,
  accordionContClassMap,
  accordionTitleClassMap,
  accordionParaClassMap,
  tcBulletImageClassMap,
  triggerIconClassMap,
  tickContainerClassMap,
  tickIconClassMap,
  bullutImgContainerClassMap,
  bullutIconClassMap,
  bullutTextClassMap,
  bullutTextContainerClassMap,
  bullutPointContainerClassMap,
  infoContainerClassMap,
  termsIconClassMap,
  lozengeImageClassMap,
  textTitleClassMap,
  cardLineGradientClassMap,
  closeImgClassMap,
  titleImgClassMap,
  legalLineTextClassMap,
  dialogTitleContainerClassMap,
  dialogTitleImgContainerClassMap,
};
